import { appType, appTypes, loadTelegramSdk } from '@/appType/appType.js'
import { getTelegramPlatform } from '@/utils/telegramLaunchParams.js'

// Telegram выполняет openLink, только если с касания прошло меньше 10 секунд, иначе молча игнорирует.
// В Telegram Web ссылку открывает window.open, а ему нужна активация пользователя (~5 секунд).
const LINK_WINDOW_MS = 9000
const WEB_LINK_WINDOW_MS = 4500

async function getOpenLink() {
  if (appType !== appTypes.TELEGRAM) {
    return null
  }

  let sdk = null
  try {
    sdk = await loadTelegramSdk()
  } catch {
    // чанк SDK не загрузился
  }

  // window.Telegram.WebApp есть только с telegram-web-app.js, которого в index.html нет
  if (sdk?.openLink?.isAvailable?.()) {
    return (url, tryBrowser) => sdk.openLink(url, tryBrowser ? { tryBrowser } : undefined)
  }
  if (window.Telegram?.WebApp?.openLink) {
    return (url, tryBrowser) => window.Telegram.WebApp.openLink(url, tryBrowser ? { try_browser: tryBrowser } : undefined)
  }
  return null
}

export async function canOpenTelegramExternalLink() {
  return Boolean(await getOpenLink())
}

/** Успеет ли openLink в окно после касания, начавшегося в startedAt. */
export function isWithinTelegramLinkWindow(startedAt) {
  if (!startedAt) {
    return true
  }
  const windowMs = /^web/i.test(getTelegramPlatform() || '') ? WEB_LINK_WINDOW_MS : LINK_WINDOW_MS
  return Date.now() - startedAt < windowMs
}

/**
 * Открыть ссылку вне Mini App (Telegram не закрывается). Telegram выполняет один openLink на одно касание.
 * @param {string} url
 * @param {{ tryBrowser?: string }} [options] tryBrowser — браузер на Android ('chrome', 'firefox'…);
 *   если он не установлен, Telegram молча ничего не открывает
 * @returns {Promise<boolean>} false — не Telegram или openLink недоступен: ссылку открывает вызывающий
 */
export async function openTelegramExternalLink(url, { tryBrowser } = {}) {
  const openLink = await getOpenLink()
  if (!openLink) {
    return false
  }

  try {
    openLink(url, tryBrowser)
    return true
  } catch (e) {
    console.warn('Telegram openLink failed', e)
    return false
  }
}
